import {
    JSX, h, Prop, Component,
} from '@stencil/core';

@Component({
    tag: 'belimo-svg-sprite',
    shadow: false,
    styleUrl: 'svg-sprite.scss',
})
export class SvgSprite {
    @Prop() public svgId = '';

    @Prop() public svgClass: string | {[className: string]: boolean} | undefined;

    @Prop() public viewBox = '0 0 24 24';

    @Prop() public width = '1em';

    @Prop() public height = '1em';

    public render(): JSX.Element {
      const use = <use
        href={`#${this.svgId}`}
        xlinkHref={`#${this.svgId}`}
      />;
      const svg = <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={this.viewBox}
        class={this.svgClass}
        width={this.width}
      >{use}</svg>;
        return (<div class="svg-sprite">{svg}</div>);
    }
}
